import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { useGetPropertyContainers } from '../../api/property/property-containers';
import { PropertyContext } from '../../context/property-context';
import FormItemSelectableList, {
  TFormItemSelectableListSchema,
  TFormItemSelectableListProps,
} from '../../ui-legacy/FormItemSelectableList';

type TData = {
  id: string;
  data: $TSFixMe;
};

export type TSelectableContainersListProps = Pick<
  TFormItemSelectableListProps<TData>,
  'preName' | 'renderItem' | 'canBeEmpty' | 'footer'
> & {
  isChangeContainerType?: boolean;
  isPickupSchemeChange?: boolean;
};

export type { TFormItemSelectableListSchema };

const SelectableContainersList = ({
  isChangeContainerType,
  isPickupSchemeChange,
  ...p
}: TSelectableContainersListProps) => {
  const { id } = useContext(PropertyContext);
  const { ticketTypeId } = useParams<{ ticketTypeId: string }>();

  const { data, isLoading } = useGetPropertyContainers(id, {
    includePrices: true,
    pricesForTicketType: ticketTypeId,
  });

  const formatData = (fetchedData: $TSFixMe) => {
    if (isPickupSchemeChange) {
      return fetchedData?.data?.filter(
        (e: {
          prices: {
            change_pickup_setting: { pickup_setting: { id: string } }[];
          };
          container: { pickup_setting: { id: string } };
        }) =>
          !!e?.prices?.change_pickup_setting?.filter(
            (v) => v.pickup_setting?.id !== e.container?.pickup_setting?.id
          )?.length
      );
    }

    return fetchedData?.data;
  };

  // For change-container-type tickets we intentionally skip the per-container
  // "has alternative types priced" filter and the ticket_type_price gate.
  // Tenants often don't configure `prices.change_container_type` even though
  // the operator-side platform UI lets them issue the ticket against any
  // container type from the tenant catalog — see ChangeContainerType for the
  // pooled-catalog dropdown.
  const formattedData =
    !ticketTypeId || isChangeContainerType
      ? formatData(data)
      : formatData(data)?.filter(
          (el: $TSFixMe) => el.ticket_type_price !== null
        );

  return (
    <FormItemSelectableList
      dataSource={formattedData?.map((node: $TSFixMe) => ({
        id: node.container.id,
        data: node,
      }))}
      loading={isLoading}
      {...p}
    />
  );
};

export default SelectableContainersList;
